import axios from "axios";
import { useEffect, useState } from "react";
import { Button } from "./DanitComponents/Buttons/Button";
import InputWithLabel from "./DanitComponents/Inputs/InputWithLabel";
import { PasswordReset } from "./PasswordReset/PasswordReset";
import { baseUrl } from "./assets/Animations";
import LoginBgTeacher from "./static/img/login-background-teacher.jpg";

const Login = ({ accessPoint, onLoggedIn }) => {
  const [schoolInfo, setSchoolInfo] = useState({
    abbreviation: "",
    schoolAbb: "",
    schoolName: "",
  });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showReset, setShowReset] = useState(false);

  useEffect(() => {
    let url = window.location.href;
    let trimmed = url.substring(8);
    let name = trimmed.split(".")[0];
    if (name === "mountainside") {
      setSchoolInfo({
        abbreviation: "MMA",
        schoolAbb: "MMA",
        schoolName: "Mountainside",
      });
    } else if (name === "lakeside") {
      setSchoolInfo({
        abbreviation: "LSMA",
        schoolAbb: "LSMA",
        schoolName: "Lakeside",
      });
    } else if (name === "treeside") {
      setSchoolInfo({
        abbreviation: "TSMA",
        schoolAbb: "TMA",
        schoolName: "Treeside",
      });
    } else if (name === "morningside") {
      setSchoolInfo({
        abbreviation: "MMA",
        schoolAbb: "MMA",
        schoolName: "Morningside",
      });
    } else if (name === "parkside") {
      setSchoolInfo({
        abbreviation: "PSMA",
        schoolAbb: "PSMA",
        schoolName: "Parkside",
      });
    } else if (name === "denton") {
      setSchoolInfo({
        abbreviation: "DEN",
        schoolAbb: "DEN",
        schoolName: "Denton",
      });
    } else if (name === "tempe") {
      setSchoolInfo({
        abbreviation: "TEM",
        schoolAbb: "TEM",
        schoolName: "Tempe",
      });
    } else if (name === "tulsa") {
      setSchoolInfo({
        abbreviation: "TUL",
        schoolAbb: "TUL",
        schoolName: "Tulsa",
      });
    }
  }, []);

  const adminSubmit = async () => {
    axios
      .post(`${baseUrl}/login`, {
        Email: email,
        Password: password,
      })
      .then((response) => {
        if (response.data.user.School === "admin") {
          onLoggedIn(response.data);
          //GETTING CONVOS
          // axios.get(`${baseUrl}/chats`)
          // .then(response => {
          //     this.props.logConvos(response.data)
          //     //checkForUnreadMessages(response.data)
          // })
          // .catch(err => {
          //     console.log(err)
          // })
        } else {
          alert("Access not granted");
        }
      })
      .catch((e) => {
        console.log(e);
        alert("Incorrect Username or Password. Please try again...");
      });
  };

  const teacherSubmit = async () => {
    let preparedEmail = email;
    preparedEmail = preparedEmail.toLowerCase().trim();
    axios
      .post(`${baseUrl}/login`, {
        Email: preparedEmail,
        Password: password,
      })
      .then((response) => {
        onLoggedIn(response.data);
      })
      .catch((e) => {
        console.log("no such user " + e);
        console.log(e);
        alert("Incorrect Username or Password. Please try again...");
      });
  };

  const toggleReset = () => {
    setShowReset(!showReset);
  };

  const isAdmin = accessPoint === "admin";
  const title = isAdmin ? "Admin Portal" : "Teacher Portal";
  const bgImage = isAdmin
    ? "./login-background.jpg"
    : schoolInfo.schoolAbb
    ? `./${schoolInfo.schoolAbb}.jpg`
    : LoginBgTeacher;

  const onSubmit = () => {
    if (isAdmin) adminSubmit();
    else teacherSubmit();
  };

  return (
    <div
      className="w-screen h-screen flex items-center justify-center bg-cover"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700 m-5">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
            {title}
          </h1>
          <PasswordReset
            resetOpen={showReset}
            schoolName={schoolInfo.schoolName}
            toggleReset={toggleReset}
          />
          <form className="space-y-4 md:space-y-6" action="#">
            <InputWithLabel
              label="Email"
              name="email"
              type="email"
              placeholder="something@company.com"
              onChange={(value) => setEmail(value)}
              value={email}
            />
            <InputWithLabel
              label="Password"
              name="password"
              type="password"
              placeholder="Password"
              onChange={(value) => setPassword(value)}
              value={password}
            />
            <div className="flex items-center justify-end">
              {/* <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="remember"
                    aria-describedby="remember"
                    type="checkbox"
                    className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                    required=""
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label
                    htmlFor="remember"
                    className="text-gray-500 dark:text-gray-300"
                  >
                    Remember me
                  </label>
                </div>
              </div> */}
              {!isAdmin && (
                <button
                  className="bg-transparent text-blue-700 hover:text-blue-300 font-semibold py-2 px-4 border border-transparent small text-sm"
                  onClick={() => toggleReset()}
                >
                  Forgot my password
                </button>
              )}
            </div>
            <Button
              color="primary"
              text="Log in"
              action={onSubmit}
              size="lg"
              fullWidth
            />
            {/* <p className="text-sm font-light text-gray-500 dark:text-gray-400">
              Don’t have an account yet?{" "}
              <a
                href="#"
                className="font-medium text-primary-600 hover:underline dark:text-primary-500"
              >
                Sign up
              </a>
            </p> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
